import React, { useState } from 'react';
import './ListPageSetup.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.

const ListPageSetup = ({ onClose, onSave, sortOptions, initialSort, initialDesc, initialRowsPerPage, total, style }) => {
  const [sort, setSort] = useState(initialSort);
  const [desc, setDesc] = useState(initialDesc);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const handleSave = () => {
    onSave({ sort, desc, rowsPerPage });
    onClose();
  };

  return (
    <div id="list_page_setup" style={style}>
      <div className="head">
        <h1>리스트 설정</h1>
        <button onClick={onClose}>닫기</button>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>정렬 기준</label>
            <span>
              <select value={sort} onChange={(e) => setSort(e.target.value)}>
                <option value="">선택하세요</option>
                {sortOptions.map((option, index) => (
                  <option key={index} value={option.value} selected={sort === option.value}>
                    {option.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>정렬 방식</label>
            <span>
              <select value={desc} onChange={(e) => setDesc(e.target.value)}>
                <option value="">선택하세요</option>
                <option value="asc" selected={desc === "asc"}>정순</option>
                <option value="desc" selected={desc === "desc"}>역순</option>
              </select>
            </span>
          </li>
          <li>
            <label>페이지당 줄 수</label>
            <span>
              <input
                type="number"
                name="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
              />
              <button onClick={() => setRowsPerPage(total)}>전체</button>
            </span>
          </li>
        </ul>
      </div>
      <div className="foot">
        <button onClick={handleSave}>저장</button>
        <button onClick={onClose}>닫기</button>
      </div>
    </div>
  );
};

export default ListPageSetup;